module.exports = "/src/views/player/help/images/mafii2.jpg";